import template from './sw-cms-preview-product-finder.html.twig';
import './sw-cms-preview-product-finder.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-product-finder', {
    template,

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        }
    }
});